import { z } from "zod/v4";
import { RecipeBase } from "../recipe-base";

export const recipeVariationKinds = ["curated", "custom"] as const;
export type RecipeVariationKind = (typeof recipeVariationKinds)[number];

export const recipeVariationPatchOps = ["create", "update", "delete"] as const;
export type RecipeVariationPatchOp = (typeof recipeVariationPatchOps)[number];

export const recipeVariationDetailsPatchSchema = z.object({
  description: z.string().nullable().optional(),
  prepTimeMinutes: z.number().nonnegative().max(RecipeBase.MAX_TIME_MINUTES).nullable().optional(),
  cookTimeMinutes: z.number().nonnegative().max(RecipeBase.MAX_TIME_MINUTES).nullable().optional(),
});
export type RecipeVariationDetailsPatch = z.infer<typeof recipeVariationDetailsPatchSchema>;

export const recipeVariationIngredientPatchDataSchema = z.object({
  amount: z.number().positive().max(RecipeBase.MAX_QUANTITY).optional(),
  sortIndex: z.string().min(1).optional(),
});
export type RecipeVariationIngredientPatchData = z.infer<
  typeof recipeVariationIngredientPatchDataSchema
>;

export const recipeVariationStepPatchDataSchema = z.object({
  text: z.string().trim().min(1).max(5000).optional(),
});
export type RecipeVariationStepPatchData = z.infer<typeof recipeVariationStepPatchDataSchema>;
